// extracted by mini-css-extract-plugin
export default {"tab":"ListTab_tab__VKZKk","active":"ListTab_active__Hj1XZ","text":"ListTab_text__pPhSK","quantity":"ListTab_quantity__tuuRN"};